import { ThresholdPill } from '@aon/aon-tws-common-ui';
import * as React from 'react';
import styled from 'styled-components';
import { Col3Col9, FormattedHeaderRow, FormattedTable, FormattedTableRow, FormattedTBodyContainer, FormattedTd, FormattedTh } from '../';
import ContentConstants from '../../../contentConstants';
import { IReportingUser, ISummaryItem } from '../../../models';
import { NoValue } from './NoValue';

export const ReportingUsersLayout = styled.div.attrs<{}>({
	className: 'tws-reporting-users-list-summary-item',
})``;
ReportingUsersLayout.displayName = 'ReportingUsersLayout';

export class ReportingUsersSummaryItem extends React.Component<ISummaryItem> {
	public render() {
		const { displayName } = this.props;

		const reportingUsers = this.props.value as IReportingUser[];

		return (
			<Col3Col9 label={displayName} subLabelDisplayData={<ThresholdPill count={reportingUsers.length} threshold={50} />}>
				<ReportingUsersLayout>
					{reportingUsers.length > 0 && (
						<FormattedTable paddingLeft={0}>
							<FormattedHeaderRow>
								<FormattedTh flexBasis={25}>{ContentConstants.TABLE_HEADER_REPORTING_FIRSTNAME}</FormattedTh>
								<FormattedTh flexBasis={25}>{ContentConstants.TABLE_HEADER_REPORTING_LASTNAME}</FormattedTh>
								<FormattedTh flexBasis={50}>{ContentConstants.TABLE_HEADER_REPORTING_EMAIL}</FormattedTh>
							</FormattedHeaderRow>
							<FormattedTBodyContainer>
								{reportingUsers.map((user: IReportingUser, key) => (
									<FormattedTableRow key={key} className='tws-reporting-user-list-item'>
										<FormattedTd flexBasis={25}>{user.firstName}</FormattedTd>
										<FormattedTd flexBasis={25}>{user.lastName}</FormattedTd>
										<FormattedTd flexBasis={50}>{user.emailAddress}</FormattedTd>
									</FormattedTableRow>
								))}
							</FormattedTBodyContainer>
						</FormattedTable>
					)}
					{reportingUsers.length === 0 && NoValue}
				</ReportingUsersLayout>
			</Col3Col9>
		);
	}
}
